import { selectWarehouse, selectWarehouseIndex } from '../Warehouses/warehousesSlice'
import { useRouteMatch, useHistory } from 'react-router-dom'
import useWarehouseAction from './hooks/useWarehouseAction'
import SlideShow from '../Warehouses/SlideShow'
import { useReduxSelector } from 'store'
import React from 'react'

interface WarehouseSlidesProps {
  id: string
}

const WarehouseSlides: React.FC<WarehouseSlidesProps> = ({ id }) => {
  const { isAlreadyOpened = false } = useReduxSelector(state => selectWarehouse(state, id))
  const index = useReduxSelector(state => selectWarehouseIndex(state, id))
  const { disabled, action } = useWarehouseAction(id)

  const { replace, push } = useHistory()
  const { path } = useRouteMatch()

  return (
    <SlideShow
      actionInAllSlides
      startIndex={index}
      action={(warehouseId, status) => {
        if (warehouseId === id && !disabled && status) {
          if (!isAlreadyOpened) push(`/firstopening/${warehouseId}`)
          else action()
        } else if (warehouseId !== id) {
          replace(path.replace(':id', warehouseId))
        }
      }} />
  )
}

export default WarehouseSlides